import React from 'react';
import { Check, Building2 } from 'lucide-react';
import { CORPORATE, IMG, CONTACT } from '../lib/butterstone';

const CorporateSection = () => (
  <section id="corporate" className="section-pad bg-[#1E3226]" data-testid="corporate-section">
    <div className="max-w-7xl mx-auto px-5 md:px-8 grid lg:grid-cols-2 gap-12 items-center">
      <div>
        <span className="overline" style={{ color: '#AFC2A4' }}>For teams &amp; groups</span>
        <h2 className="font-serif text-4xl md:text-6xl mt-4 text-white">Corporate &amp; group packages</h2>
        <p className="text-white/75 mt-5 leading-relaxed">
          Bring your team to the river. Butterstone is built for offsites, celebrations and large groups — with dormitories for up to 26, open lawns, adventure circuits and all-inclusive food &amp; activity plans.
        </p>
        <div className="grid sm:grid-cols-2 gap-3 mt-7">
          {CORPORATE.perks.map((p, i) => (
            <div key={i} className="flex items-start gap-3">
              <span className="w-6 h-6 rounded-full bg-[#6E9A5E]/20 flex items-center justify-center flex-shrink-0 mt-0.5"><Check size={14} className="text-[#AFC2A4]" /></span>
              <span className="text-white/85 text-sm">{p}</span>
            </div>
          ))}
        </div>
        <a href={`https://wa.me/${CONTACT.whatsapp}?text=${encodeURIComponent('Hi Butterstone, I would like a corporate/group package quote.')}`} target="_blank" rel="noreferrer" className="btn-light mt-8" data-testid="corporate-cta"><Building2 size={16} /> Request a Group Quote</a>
      </div>
      <div className="grid grid-cols-2 gap-3">
        <img src={IMG.zip1} alt="team activity" className="rounded-lg h-56 md:h-72 w-full object-cover" />
        <img src={IMG.volley1} alt="mud volleyball" className="rounded-lg h-56 md:h-72 w-full object-cover mt-8" />
        <img src={IMG.dorm} alt="dormitory" className="rounded-lg h-44 w-full object-cover" />
        <img src={IMG.pool} alt="pool" className="rounded-lg h-44 w-full object-cover -mt-4" />
      </div>
    </div>
  </section>
);

export default CorporateSection;
